import { render, staticRenderFns } from "./TheModalWindow.vue?vue&type=template&id=08f02b73&scoped=true"
import script from "./TheModalWindow.vue?vue&type=script&lang=js"
export * from "./TheModalWindow.vue?vue&type=script&lang=js"
import style1 from "./TheModalWindow.vue?vue&type=style&index=1&id=08f02b73&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08f02b73",
  null
  
)

export default component.exports